<template>
  <div detail-image>
    <CardImage :img="img"/>
    <img :src="img"/>
  </div>
</template>

<script>
import CardImage from '@/views/components/CardImage';
export default {
  name: 'DetailImage',
  components: { CardImage },
  props: {
    img: { type: String },
  },
};
</script>

<style lang="less">
@import "~@/less/proj";
[detail-image] {
  [card-image] { .hf; }
  img { .hide; }
}

@media (min-width: @screen-md-min) {
  [detail-image] {
    [card-image] { .hide; }
    img { .block; .wf; }
  }
}
</style>
